module.exports = __webpack_public_path__ + "static/media/home-red.5ee9dc7f.svg";